import { ITableColumn } from '../../components';
import { IColumn } from '../types';
import {
  createColumnRenderer,
  createColumnValueRenderer,
} from './createColumnRenderer';
import { normalizeDataIndex } from './normalizeDataIndex';

export const mapToTableColumns = <T extends Record<string, unknown>>({
  columns,
  context,
  rowName,
  sortName,
  sortOrder,
}: {
  columns: IColumn[];
  context: any;
  rowName?: string;
  sortName?: string | null;
  sortOrder?: 'ascend' | 'descend';
}): ITableColumn<T>[] =>
  columns.map(col => {
    const key = normalizeDataIndex(col.dataIndex) || col.id;
    const columnSortName = col.sortName || key;
    return {
      ...col,
      key: key,
      align: col.align,
      width: col.width,
      fixed: col.fixed === false ? undefined : col.fixed,
      ellipsis: col.ellipsis,
      sorter: col.sorter,
      sortOrder: sortName === columnSortName ? sortOrder : null,
      render: createColumnValueRenderer({
        column: col,
        formatter: createColumnRenderer(col.format),
        context,
        rowName,
      }),
    };
  });
